import React from 'react';
import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LanguageIcon from '@mui/icons-material/Language';

const languages = [
  { code: 'tr', name: 'Türkçe', dir: 'ltr' },
  { code: 'en', name: 'English', dir: 'ltr' },
  { code: 'de', name: 'Deutsch', dir: 'ltr' },
  { code: 'ar', name: 'العربية', dir: 'rtl' },
  { code: 'fr', name: 'Français', dir: 'ltr' },
  { code: 'ru', name: 'Русский', dir: 'ltr' },
];

const LanguageSelector = () => {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (languageCode, dir) => {
    i18n.changeLanguage(languageCode);
    document.documentElement.dir = dir;
    handleClose();
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <IconButton
        onClick={handleClick}
        sx={{
          color: 'secondary.main',
          '&:hover': {
            backgroundColor: 'rgba(197, 164, 126, 0.08)',
          },
        }}
      >
        <LanguageIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            mt: 1.5,
            backgroundColor: 'primary.main',
            boxShadow: 4,
            border: '1px solid',
            borderColor: 'secondary.main',
            '& .MuiList-root': {
              padding: '8px 0',
            },
          },
        }}
        MenuListProps={{
          sx: {
            backgroundColor: 'primary.main',
          },
        }}
      >
        {languages.map((language) => (
          <MenuItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code, language.dir)}
            selected={i18n.language === language.code}
            sx={{
              py: 1,
              px: 2,
              color: 'secondary.main',
              '&:hover': {
                backgroundColor: 'rgba(197, 164, 126, 0.16)',
              },
              '&.Mui-selected': {
                backgroundColor: 'rgba(197, 164, 126, 0.24)',
                '&:hover': {
                  backgroundColor: 'rgba(197, 164, 126, 0.32)',
                },
              },
            }}
          >
            <Typography variant="body2">
              {t(`language.${language.code}`)}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageSelector; 